/**
 * Generic deferred-display (pending) pattern for growler services.
 *
 * Concrete services call setPendingData() to queue a payload and must implement
 * showPending() to perform the actual growler display.  showPendingIfAny() drains
 * the queue — call it from the target page's init so the growler shows after
 * any page-level growlers have already fired.
 */
export abstract class GrowlerPendingService<T> {
  private _pendingData: T | null = null;

  protected setPendingData(data: T): void {
    this._pendingData = data;
  }

  showPendingIfAny(): void {
    if (!this._pendingData) return;
    const data = this._pendingData;
    this._pendingData = null;
    this.showPending(data);
  }

  protected abstract showPending(data: T): void;
}
